var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdjustmentsVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8C3.72386 8 3.5 7.77614 3.5 7.5L3.50001 2.5C3.50001 2.22386 3.72387 2 4.00001 2C4.27615 2 4.50001 2.22386 4.50001 2.5L4.5 7.5C4.5 7.77614 4.27614 8 4 8Z",
    fill: "#010F55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8C11.7239 8 11.5 7.77614 11.5 7.5L11.5 2.5C11.5 2.22386 11.7239 2 12 2C12.2762 2 12.5 2.22386 12.5 2.5L12.5 7.5C12.5 7.77614 12.2761 8 12 8Z",
    fill: "#010F55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50001 13.5L4.5 12.5C4.5 12.2239 4.27614 12 4 12C3.72385 12 3.5 12.2239 3.5 12.5L3.50001 13.5C3.50001 13.7761 3.72387 14 4.00001 14C4.27616 14 4.50001 13.7761 4.50001 13.5Z",
    fill: "#010F55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.5L12.5 13.5C12.5 13.7761 12.2762 14 12 14C11.7239 14 11.5 13.7761 11.5 13.5L11.5 12.5C11.5 12.2239 11.7239 12 12 12C12.2761 12 12.5 12.2239 12.5 12.5Z",
    fill: "#010F55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50001 3.5L8.5 2.5C8.5 2.22385 8.27614 2 8 2C7.72385 2 7.5 2.22386 7.5 2.5L7.50001 3.5C7.50001 3.77615 7.72387 4 8.00001 4C8.27616 4 8.50001 3.77614 8.50001 3.5Z",
    fill: "#010F55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14C7.72386 14 7.5 13.7761 7.5 13.5V8.5C7.5 8.22386 7.72386 8 8 8C8.27614 8 8.5 8.22386 8.5 8.5V13.5C8.5 13.7761 8.27614 14 8 14Z",
    fill: "#010F55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10C2.5 10.8284 3.17157 11.5 4 11.5C4.82843 11.5 5.5 10.8284 5.5 10C5.5 9.17157 4.82843 8.5 4 8.5C3.17157 8.5 2.5 9.17157 2.5 10Z",
    fill: "#010F55"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.5C7.17157 7.5 6.5 6.82843 6.5 6C6.5 5.17157 7.17157 4.5 8 4.5C8.82843 4.5 9.5 5.17157 9.5 6C9.5 6.82843 8.82843 7.5 8 7.5Z",
    fill: "#010F55"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10C10.5 10.8284 11.1716 11.5 12 11.5C12.8284 11.5 13.5 10.8284 13.5 10C13.5 9.17157 12.8284 8.5 12 8.5C11.1716 8.5 10.5 9.17157 10.5 10Z",
    fill: "#010F55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdjustmentsVertical);
export default __webpack_public_path__ + "static/media/AdjustmentsVertical.41aad6d6c27d1a8dab4f41abc7cd7bfe.svg";
export { ForwardRef as ReactComponent };